(function () {
  const gallerySelector = '[data-card-gallery]';

  function getElements(control) {
    const media = control.closest('.card-media');
    const images = media ? Array.from(media.querySelectorAll(':scope > [data-card-gallery-image]')) : [];
    return { media, images };
  }

  function loadImage(image) {
    if (!image || !image.dataset.cardGallerySrc) return;
    image.src = image.dataset.cardGallerySrc;
    delete image.dataset.cardGallerySrc;
  }

  function showImage(control, requestedIndex) {
    const { media, images } = getElements(control);
    if (!media || images.length < 2) return;

    const index = (requestedIndex + images.length) % images.length;
    const selected = images[index];
    loadImage(selected);

    media.classList.add('has-card-gallery', 'is-card-gallery-active');
    media.dataset.cardGalleryIndex = String(index);

    images.forEach((image, imageIndex) => {
      const active = imageIndex === index;
      image.classList.toggle('is-card-gallery-current', active);
      image.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    const status = control.querySelector('[data-card-gallery-status]');
    if (status) status.textContent = `Imagem ${index + 1} de ${images.length}`;
  }

  function initializeGallery(control) {
    if (control.dataset.cardGalleryReady === 'true') return;
    const { media, images } = getElements(control);
    if (!media || images.length < 2) return;

    control.dataset.cardGalleryReady = 'true';
    media.classList.add('has-card-gallery');
    media.dataset.cardGalleryIndex = '0';
    images.forEach((image, index) => image.setAttribute('aria-hidden', index === 0 ? 'false' : 'true'));
  }

  function initializeAll(root) {
    root.querySelectorAll(gallerySelector).forEach(initializeGallery);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-card-gallery-previous], [data-card-gallery-next]');
    if (!button) return;

    const control = button.closest(gallerySelector);
    if (!control) return;

    event.preventDefault();
    event.stopPropagation();
    initializeGallery(control);

    const { media, images } = getElements(control);
    let current = Number(media.dataset.cardGalleryIndex || 0);

    /* Antes da primeira seta, o hover do desktop já exibe visualmente a foto 2. */
    if (
      !media.classList.contains('is-card-gallery-active') &&
      images.length > 1 &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      media.matches(':hover')
    ) {
      current = 1;
    }

    showImage(control, current + (button.hasAttribute('data-card-gallery-next') ? 1 : -1));
  });

  document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches(gallerySelector)) initializeGallery(node);
        initializeAll(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
